import React from "react";
import { createPortal } from "react-dom";
import DeckCardExpandModal from "./DeckCardExpand/DeckCardExpandModal";
import { DeckCardKakaoKind } from "@/modules/kakao";
import { PublishedCard } from "../../types";
import { DeckCardThumbnailRecord } from "../../types/app-deck/deckCardThumbnail.types";

export type DeckCardLibraryExpandPortalProps = {
  open: boolean;
  onClose: () => void;
  onDismiss?: () => void;
  card: PublishedCard | null;
  thumbnail?: DeckCardThumbnailRecord | null;
  onOpenDetails: (card: PublishedCard) => void;
  onShare?: (card: PublishedCard) => void;
  deckCardShareKind?: DeckCardKakaoKind;
  addBorder?: boolean;
};

const DeckCardLibraryExpandPortal: React.FC<DeckCardLibraryExpandPortalProps> = (props) => {
  if (typeof document === "undefined") return null;
  return createPortal(<DeckCardExpandModal {...props} />, document.body);
};

export default DeckCardLibraryExpandPortal;
